import React, { useEffect, useState } from "react";
import DotedPart from "../common/DotedPart";
import ExploreandExperience from "./ExploreandExperience";
import HomeDashboardPart from "./HomeDashboardPart";
import HomePageMain from "./HomePageMain";
import HomeTakeExport from "./HomeTakeExport";
import HomeGetCompliant from "./HomeGetCompliant";
import { useTranslation } from "react-i18next";

const IndexFirst = () => {
  const { t } = useTranslation();
  const [isWideScreen, setIsWideScreen] = useState(window.innerWidth >= 1024);
  const [isMobileScreen, setIsMobileScreen] = useState(window.innerWidth >= 640);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
      setIsWideScreen(window.innerWidth >= 1024);
      setIsMobileScreen(window.innerWidth >= 640)
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [])


  return (
    <>
      <HomePageMain isWideScreen={isWideScreen} isMobileScreen={isMobileScreen} />
      {/* <Marque className="mb-[0px] mt-[50px] 2xl:mb-24 2xl:mt-24 " title={"Trusted By Web3’s Most Innovative Teams"} /> */}
      <HomeDashboardPart isWideScreen={isWideScreen} screenWidth={screenWidth} />
      {/* <HomeCounterPart /> */}
      <HomeTakeExport
        content={t("assist_description")}
        className={`${isWideScreen ? "mt-8 md:mt-0" : "mt-12"} mb-[20px] md:mb-0`}
      />
      <DotedPart className="my-[50px] md:my-[89px]" />
      <ExploreandExperience />
      <HomeGetCompliant
        content={t("choose_vitta_desc")}
        className="mt-8 md:mt-0 mb-[20px] md:mb-0"
      />
      <DotedPart className="my-[50px] md:my-[89px]" />
    </>
  );
};

export default IndexFirst;
